import {saveAs} from 'file-saver';
import type {ForestMass} from '@/domain/entities/ForestMass';
import type {ForestMassRepository} from '@/domain/interfaces/ForestMassRepository';

export class DownloadGpkgForestMassUseCase {
  constructor(private readonly repository: ForestMassRepository) {}
  async execute(forestMass: ForestMass) {
    try {
      const blob = await this.repository.download(forestMass.uuid);
      saveAs(blob, `${forestMass.code}.gpkg`);
    } catch (error) {
      console.error('Error downloading forest mass gpkg', error);
      throw error;
    }
  }
}
